module.exports = __webpack_public_path__ + "img/bluesky.41f2cc9b.svg";